import { ActivityFeed } from '../activity/ActivityFeed.js';
import { BlockersWidget } from './BlockersWidget.js';
import { StagePipelineWidget } from './StagePipelineWidget.js';
import { RegenerationFlagsWidget } from './RegenerationFlagsWidget.js';

/** The main dashboard: an org-wide summary of every project the user can see — blockers, stage
 * pipeline, regeneration impact — plus a live activity feed (project filtering happens on each
 * project's own Activity tab instead — see docs/PLAN.md §7.2). */
export function DashboardPage() {
  return (
    <div className="mx-auto flex max-w-4xl flex-col gap-4 p-4 sm:gap-6 sm:p-6">
      <div>
        <h1 className="text-lg font-semibold">Dashboard</h1>
        <p className="text-sm text-muted">Live activity across every project you can see.</p>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.5fr)] lg:items-start">
        <div className="flex min-w-0 flex-col gap-4 sm:gap-6">
          <BlockersWidget />
          <StagePipelineWidget />
          <RegenerationFlagsWidget />
        </div>
        <ActivityFeed />
      </div>
    </div>
  );
}
